export enum AppointmentChanel {
  Paciente = 1,
  Membro = 2,
  Secretaria = 3,
  Google = 4,
}
